import { CheckCircle2, Clock } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";

export const TesseraImage = ({ m }) => {
  const src = `${process.env.REACT_APP_BACKEND_URL}/api/memberships/${m.id}/tessera.jpg`;
  return (
    <div className="max-w-xl w-full fade-up space-y-3">
      <img src={src} alt={`Tessera ${m.tessera_numero}`} className="w-full aspect-[1024/645] rounded-2xl shadow-2xl bg-slate-200" data-testid="tessera-image" />
      <div className="flex items-center gap-4">
        <a href={src} download={`tessera_${m.anno}.jpg`} className="inline-flex items-center gap-2 bg-[#0B192C] hover:bg-[#1E3E62] text-white text-sm px-4 py-2 rounded-full transition-colors" data-testid="tessera-download-button">Scarica tessera</a>
        <span className="text-sm" data-testid="tessera-payment-status">
          {m.pagamento_confermato ? <span className="inline-flex items-center gap-1 text-emerald-700 font-semibold"><CheckCircle2 className="h-4 w-4" />Pagamento confermato</span>
            : <span className="inline-flex items-center gap-1 text-amber-600 font-semibold"><Clock className="h-4 w-4" />Pagamento in verifica</span>}
        </span>
      </div>
    </div>
  );
};

export const TesseraQR = ({ m }) => {
  const url = `${window.location.origin}/verifica/${m.id}`;
  return (
    <div className="flex flex-col sm:flex-row items-center gap-5" data-testid="tessera-qr">
      <div className="bg-white p-3 rounded-xl border"><QRCodeSVG value={url} size={148} level="M" fgColor="#0B192C" /></div>
      <div className="text-sm text-muted-foreground">
        <div className="font-heading text-lg uppercase text-[#0B192C]">QR di verifica</div>
        Mostra questo codice al controllo: chi lo scansiona vede se la tessera è valida per l'anno in corso.
        <a href={url} target="_blank" rel="noreferrer" className="block mt-2 text-emerald-700 hover:underline" data-testid="tessera-qr-link">Apri pagina di verifica</a>
      </div>
    </div>
  );
};

export const TesseraCard = ({ m }) => (
  <div className="relative overflow-hidden rounded-2xl text-white aspect-[1.6/1] max-w-xl w-full shadow-2xl fade-up grain"
    style={{ background: "linear-gradient(135deg,#0B192C 0%,#1E3E62 55%,#0B192C 100%)" }} data-testid="tessera-card">
    <div className="absolute -right-16 -top-16 h-64 w-64 rounded-full bg-emerald-500/10 blur-2xl" />
    <div className="absolute left-0 top-0 bottom-0 w-2 flex flex-col">
      <div className="flex-1 bg-emerald-600" /><div className="flex-1 bg-white" /><div className="flex-1 bg-red-600" />
    </div>
    <div className="relative h-full flex flex-col justify-between p-6 sm:p-8 pl-8 sm:pl-10">
      <div className="flex items-start justify-between">
        <div>
          <div className="text-[10px] font-mono-x uppercase tracking-[0.25em] text-slate-300">Associazione italiana Classi Nacra-9er</div>
          <div className="font-heading text-2xl uppercase tracking-wide">Tessera Socio</div>
        </div>
        <img src="/logo-9er.png" alt="9er" className="h-12 w-12 sm:h-14 sm:w-14 bg-white rounded-lg p-1" />
      </div>
      <div>
        <div className="text-[10px] font-mono-x uppercase tracking-[0.25em] text-slate-400">N. tessera</div>
        <div className="font-mono-x text-3xl sm:text-4xl font-semibold tracking-wider" data-testid="tessera-numero">{m.tessera_numero}</div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
        <div className="col-span-2">
          <div className="text-[10px] font-mono-x uppercase tracking-widest text-slate-400">Socio</div>
          <div className="font-semibold uppercase" data-testid="tessera-nominativo">{m.cognome} {m.nome}</div>
        </div>
        <div>
          <div className="text-[10px] font-mono-x uppercase tracking-widest text-slate-400">Validità</div>
          <div className="font-semibold" data-testid="tessera-anno">01/01 – 31/12/{m.anno}</div>
        </div>
        <div>
          <div className="text-[10px] font-mono-x uppercase tracking-widest text-slate-400">Barca</div>
          <div className="font-semibold" data-testid="tessera-categoria-barca">{m.categoria_barca || "—"}</div>
        </div>
        <div className="col-span-2 sm:col-span-3">
          <div className="text-[10px] font-mono-x uppercase tracking-widest text-slate-400">Categoria socio</div>
          <div className="font-semibold" data-testid="tessera-categoria-socio">{m.categoria_socio}</div>
        </div>
        <div className="flex items-end" data-testid="tessera-payment-status">
          {m.pagamento_confermato ? (
            <span className="inline-flex items-center gap-1 text-emerald-400 text-xs font-semibold uppercase"><CheckCircle2 className="h-4 w-4" />Pagato</span>
          ) : (
            <span className="inline-flex items-center gap-1 text-amber-400 text-xs font-semibold uppercase"><Clock className="h-4 w-4" />In verifica</span>
          )}
        </div>
      </div>
    </div>
  </div>
);
